import {isNotNil} from 'ramda';

import {VehicleSelectionPreviewItemResponseBody} from '@dms/api/sales';

import {EMPTY_PLACEHOLDER} from 'shared/web';

import {stripVehicleSelectionCodePrefix} from './stripVehicleSelectionCodePrefix';

export const formatVehicleSelectionVehicleTitle = (
  item: Pick<VehicleSelectionPreviewItemResponseBody, 'make' | 'model'>
) => {
  const parts = [item.make, item.model].filter(isNotNil).map(stripVehicleSelectionCodePrefix);

  return parts.length > 0 ? parts.join(' ') : EMPTY_PLACEHOLDER;
};
